// extracted by mini-css-extract-plugin
export default {"admin-panel":"admin-panel__LhSdC","adminPanel":"admin-panel__LhSdC"};